export enum CarouselTypeEnum {
  OTHERS_VISITED = 'others-visited',
  SIMILAR_PRODUCTS = 'similar-products',
  TRENDING_PRODUCTS = 'trending-products',
  OTHER_POPULAR_PRODUCTS = 'other-popular-products',
  PERSONALIZED = 'personalized',
}
